import React from 'react'
import PropTypes from 'prop-types'
import getEnv from '../../utils/env'

const CMPTag = (props) => {
  const env = getEnv()
  if (props?.layout === 'standAlonePage') return null
  const scriptSrc = env === 'testing' ? '' : 'https://cdn-ukwest.onetrust.com/scripttemplates/otSDKStub.js'
  const dataDomain = env === 'production'
    ? '035926c5-0f92-44e8-b64b-151b2ef26023'
    : '7b57d42b-e1f4-4685-90ad-6b7199e18a25-test'
  return (
    <>
      <script
        id="oneTrustScript"
        url={scriptSrc}
        data-domain-script={dataDomain}
        src={scriptSrc}
      />
    </>
  )
}
CMPTag.propTypes = {
  layout: PropTypes.string,
}
CMPTag.defaultProps = {
  layout: 'default',
}
export default CMPTag
